import { Button, Form, Header, SpaceBetween, Spinner } from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import ExceptionForm from '../ExceptionForm';
import { useExceptionForm } from '../ExceptionForm/useExceptionForm';
import { useRouteLoadDurationPublisher } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';

export type ExceptionFormMatchParams = {
  exceptionId: string;
};

export default function EditExceptionForm(): ReactElement {
  const publishRouteLoadDuration = useRouteLoadDurationPublisher();
  const { t } = useTranslation();
  const history = useHistory();
  const { exceptionId } = useParams<ExceptionFormMatchParams>();
  const { form, fetchError, fetchingException, assignedToGroups } = useExceptionForm(exceptionId);

  if (fetchingException) {
    return <Spinner size="big" />;
  }
  publishRouteLoadDuration();

  return (
    <div className="small-form-max-width">
      <Form
        actions={
          !fetchError && (
            <SpaceBetween direction="horizontal" size="xs">
              {exceptionId && (
                <Button
                  data-test-id="cancel"
                  disabled={form.isSubmitting}
                  variant="link"
                  onClick={() => history.goBack()}>
                  {t('Cancel')}
                </Button>
              )}

              <Button
                data-test-id="submit"
                loading={form.isSubmitting || form.isValidating}
                variant="primary"
                onClick={() => form.handleSubmit()}>
                {t('Update exception')}
              </Button>
            </SpaceBetween>
          )
        }
        header={
          <>
            <Header variant="h1" description={exceptionId}>
              {t('Edit Exception Detail')}
            </Header>
          </>
        }>
        <ExceptionForm
          form={form}
          isEditForm
          fetchError={fetchError}
          assignedToGroups={assignedToGroups}
        />
      </Form>
    </div>
  );
}
